import { render, staticRenderFns } from "./Periodos.vue?vue&type=template&id=bcdd8acc&scoped=true"
import script from "./Periodos.vue?vue&type=script&lang=js"
export * from "./Periodos.vue?vue&type=script&lang=js"
import style0 from "./Periodos.vue?vue&type=style&index=0&id=bcdd8acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdd8acc",
  null
  
)

export default component.exports